interface CountryInfo {
  country: string;
  countryCode: string;
}

export interface GroupedByCountry {
  [key: string]: CountryInfo;
}

export const groupByCountry = (data: Record<string, string>): GroupedByCountry => {
  const groupedData = Object.entries(data ?? {})
    .filter(([key]) => key.startsWith('country.'))
    .reduce((result, [key, country]) => {
      const countryCode = key.substring('country.'.length);
      const countryInfo: CountryInfo = {
        country,
        countryCode: `${data[`phone.country.${countryCode}`]}`,
      };
      return { ...result, [countryCode.toUpperCase()]: countryInfo };
    }, {} as GroupedByCountry);

  const sortedData = Object.fromEntries(
    Object.entries(groupedData).sort((a, b) => a[1].country.localeCompare(b[1].country)),
  );

  return sortedData;
};
